import { TaskType } from '@shared/enums/task-type.enum';
import { SubtasksService } from './../../subtasks.service';
import { ButtonTypes, ButtonSize } from '@shared/modules/ui/components/button/button.component';
import { ChangeDetectionStrategy, Component, ChangeDetectorRef, Input, signal } from '@angular/core';
import { Task } from '@shared/models/task.model';
import { sortListByGroup } from '@shared/helpers/list-sort.helper';
import { sortTasks } from '@shared/helpers/sort-tasks.helper';

@Component({
  selector: 'subtasks-manager',
  templateUrl: './subtasks-manager.component.html',
  styleUrls: ['./subtasks-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubtasksManagerComponent {
  ButtonTypes = ButtonTypes;
  ButtonSize = ButtonSize;

  protected addingTask = signal(false);

  @Input()
  set disabled(disabled: boolean) {
    this.service.disabled = disabled;
    this.changes.detectChanges();
  }

  get disabled(): boolean {
    return this.service.disabled;
  }

  @Input()
  set parentId(parentId: number) {
    this.service.parentId = parentId;
    this.changes.detectChanges();
  }

  get parentId(): number {
    return this.service.parentId;
  }

  @Input()
  set parentTask(task: Task) {
    this.service.parentTask = task;
    this.changes.detectChanges();
  }

  get parentTask(): Task {
    return this.service.parentTask;
  }

  @Input()
  set type(type: TaskType) {
    this.service.type = type;
    this.changes.detectChanges();
  }

  get type(): TaskType {
    return this.service.type;
  }

  @Input()
  set taskList(taskList: Task[]) {
    let filtered = taskList ? [...taskList.filter((i) => i.type !== TaskType.TYPE_CHANGE)] : [];
    filtered = sortListByGroup(filtered);
    filtered.sort(sortTasks);

    this.service.setTaskList(filtered);
    this.changes.detectChanges();
  }

  get taskList(): Task[] {
    return this.service.taskListSnapshot;
  }

  constructor(
    private changes: ChangeDetectorRef,
    public service: SubtasksService
  ) {}

  addTask() {
    this.addingTask.set(true);
    this.changes.detectChanges();
  }

  discardAdding() {
    this.addingTask.set(false);
    this.changes.detectChanges();
  }
}
